import AD from './images/svg/flags/ad.svg';
import AE from './images/svg/flags/ae.svg';
import AF from './images/svg/flags/af.svg';
import AG from './images/svg/flags/ag.svg';
import AI from './images/svg/flags/ai.svg';
import AL from './images/svg/flags/al.svg';
import AM from './images/svg/flags/am.svg';
import AN from './images/svg/flags/an.svg';
import AO from './images/svg/flags/ao.svg';
import AQ from './images/svg/flags/aq.svg';
import AR from './images/svg/flags/ar.svg';
import AS from './images/svg/flags/as.svg';
import AT from './images/svg/flags/at.svg';
import AU from './images/svg/flags/au.svg';
import AW from './images/svg/flags/aw.svg';
import AX from './images/svg/flags/ax.svg';
import AZ from './images/svg/flags/az.svg';
import BA from './images/svg/flags/ba.svg';
import BB from './images/svg/flags/bb.svg';
import BD from './images/svg/flags/bd.svg';
import BE from './images/svg/flags/be.svg';
import BF from './images/svg/flags/bf.svg';
import BG from './images/svg/flags/bg.svg';
import BH from './images/svg/flags/bh.svg';
import BI from './images/svg/flags/bi.svg';
import BJ from './images/svg/flags/bj.svg';
import BL from './images/svg/flags/bl.svg';
import BM from './images/svg/flags/bm.svg';
import BN from './images/svg/flags/bn.svg';
import BO from './images/svg/flags/bo.svg';
import BQ from './images/svg/flags/bq.svg';
import BR from './images/svg/flags/br.svg';
import BS from './images/svg/flags/bs.svg';
import BT from './images/svg/flags/bt.svg';
import BV from './images/svg/flags/bv.svg';
import BW from './images/svg/flags/bw.svg';
import BY from './images/svg/flags/by.svg';
import BZ from './images/svg/flags/bz.svg';
import CA from './images/svg/flags/ca.svg';
import CC from './images/svg/flags/cc.svg';
import CD from './images/svg/flags/cd.svg';
import CF from './images/svg/flags/cf.svg';
import CG from './images/svg/flags/cg.svg';
import CH from './images/svg/flags/ch.svg';
import CI from './images/svg/flags/ci.svg';
import CK from './images/svg/flags/ck.svg';
import CL from './images/svg/flags/cl.svg';
import CM from './images/svg/flags/cm.svg';
import CN from './images/svg/flags/cn.svg';
import CO from './images/svg/flags/co.svg';
import CR from './images/svg/flags/cr.svg';
import CU from './images/svg/flags/cu.svg';
import CV from './images/svg/flags/cv.svg';
import CW from './images/svg/flags/cw.svg';
import CX from './images/svg/flags/cx.svg';
import CY from './images/svg/flags/cy.svg';
import CZ from './images/svg/flags/cz.svg';
import DE from './images/svg/flags/de.svg';
import DJ from './images/svg/flags/dj.svg';
import DK from './images/svg/flags/dk.svg';
import DM from './images/svg/flags/dm.svg';
import DO from './images/svg/flags/do.svg';
import DZ from './images/svg/flags/dz.svg';
import EC from './images/svg/flags/ec.svg';
import EE from './images/svg/flags/ee.svg';
import EG from './images/svg/flags/eg.svg';
import EH from './images/svg/flags/eh.svg';
import ER from './images/svg/flags/er.svg';
import ES from './images/svg/flags/es.svg';
import ET from './images/svg/flags/et.svg';
import FI from './images/svg/flags/fi.svg';
import FJ from './images/svg/flags/fj.svg';
import FK from './images/svg/flags/fk.svg';
import FM from './images/svg/flags/fm.svg';
import FO from './images/svg/flags/fo.svg';
import FR from './images/svg/flags/fr.svg';
import GA from './images/svg/flags/ga.svg';
import GB from './images/svg/flags/gb.svg';
import GD from './images/svg/flags/gd.svg';
import GE from './images/svg/flags/ge.svg';
import GF from './images/svg/flags/gf.svg';
import GG from './images/svg/flags/gg.svg';
import GH from './images/svg/flags/gh.svg';
import GI from './images/svg/flags/gi.svg';
import GL from './images/svg/flags/gl.svg';
import GM from './images/svg/flags/gm.svg';
import GN from './images/svg/flags/gn.svg';
import GP from './images/svg/flags/gp.svg';
import GQ from './images/svg/flags/gq.svg';
import GR from './images/svg/flags/gr.svg';
import GS from './images/svg/flags/gs.svg';
import GT from './images/svg/flags/gt.svg';
import GU from './images/svg/flags/gu.svg';
import GW from './images/svg/flags/gw.svg';
import GY from './images/svg/flags/gy.svg';
import HK from './images/svg/flags/hk.svg';
import HM from './images/svg/flags/hm.svg';
import HN from './images/svg/flags/hn.svg';
import HR from './images/svg/flags/hr.svg';
import HT from './images/svg/flags/ht.svg';
import HU from './images/svg/flags/hu.svg';
import ID from './images/svg/flags/id.svg';
import IE from './images/svg/flags/ie.svg';
import IL from './images/svg/flags/il.svg';
import IM from './images/svg/flags/im.svg';
import IN from './images/svg/flags/in.svg';
import IO from './images/svg/flags/io.svg';
import IQ from './images/svg/flags/iq.svg';
import IR from './images/svg/flags/ir.svg';
import IS from './images/svg/flags/is.svg';
import IT from './images/svg/flags/it.svg';
import JE from './images/svg/flags/je.svg';
import JM from './images/svg/flags/jm.svg';
import JO from './images/svg/flags/jo.svg';
import JP from './images/svg/flags/jp.svg';
import KE from './images/svg/flags/ke.svg';
import KG from './images/svg/flags/kg.svg';
import KH from './images/svg/flags/kh.svg';
import KI from './images/svg/flags/ki.svg';
import KM from './images/svg/flags/km.svg';
import KN from './images/svg/flags/kn.svg';
import KP from './images/svg/flags/kp.svg';
import KR from './images/svg/flags/kr.svg';
import KW from './images/svg/flags/kw.svg';
import KY from './images/svg/flags/ky.svg';
import KZ from './images/svg/flags/kz.svg';
import LA from './images/svg/flags/la.svg';
import LB from './images/svg/flags/lb.svg';
import LC from './images/svg/flags/lc.svg';
import LI from './images/svg/flags/li.svg';
import LK from './images/svg/flags/lk.svg';
import LR from './images/svg/flags/lr.svg';
import LS from './images/svg/flags/ls.svg';
import LT from './images/svg/flags/lt.svg';
import LU from './images/svg/flags/lu.svg';
import LV from './images/svg/flags/lv.svg';
import LY from './images/svg/flags/ly.svg';
import MA from './images/svg/flags/ma.svg';
import MC from './images/svg/flags/mc.svg';
import MD from './images/svg/flags/md.svg';
import ME from './images/svg/flags/me.svg';
import MF from './images/svg/flags/mf.svg';
import MG from './images/svg/flags/mg.svg';
import MH from './images/svg/flags/mh.svg';
import MK from './images/svg/flags/mk.svg';
import ML from './images/svg/flags/ml.svg';
import MM from './images/svg/flags/mm.svg';
import MN from './images/svg/flags/mn.svg';
import MO from './images/svg/flags/mo.svg';
import MP from './images/svg/flags/mp.svg';
import MQ from './images/svg/flags/mq.svg';
import MR from './images/svg/flags/mr.svg';
import MS from './images/svg/flags/ms.svg';
import MT from './images/svg/flags/mt.svg';
import MU from './images/svg/flags/mu.svg';
import MV from './images/svg/flags/mv.svg';
import MW from './images/svg/flags/mw.svg';
import MX from './images/svg/flags/mx.svg';
import MY from './images/svg/flags/my.svg';
import MZ from './images/svg/flags/mz.svg';
import NA from './images/svg/flags/na.svg';
import NC from './images/svg/flags/nc.svg';
import NE from './images/svg/flags/ne.svg';
import NF from './images/svg/flags/nf.svg';
import NG from './images/svg/flags/ng.svg';
import NI from './images/svg/flags/ni.svg';
import NL from './images/svg/flags/nl.svg';
import NO from './images/svg/flags/no.svg';
import NP from './images/svg/flags/np.svg';
import NR from './images/svg/flags/nr.svg';
import NU from './images/svg/flags/nu.svg';
import NZ from './images/svg/flags/nz.svg';
import OM from './images/svg/flags/om.svg';
import PA from './images/svg/flags/pa.svg';
import PE from './images/svg/flags/pe.svg';
import PF from './images/svg/flags/pf.svg';
import PG from './images/svg/flags/pg.svg';
import PH from './images/svg/flags/ph.svg';
import PK from './images/svg/flags/pk.svg';
import PL from './images/svg/flags/pl.svg';
import PM from './images/svg/flags/pm.svg';
import PN from './images/svg/flags/pn.svg';
import PR from './images/svg/flags/pr.svg';
import PS from './images/svg/flags/ps.svg';
import PT from './images/svg/flags/pt.svg';
import PW from './images/svg/flags/pw.svg';
import PY from './images/svg/flags/py.svg';
import QA from './images/svg/flags/qa.svg';
import RE from './images/svg/flags/re.svg';
import RO from './images/svg/flags/ro.svg';
import RS from './images/svg/flags/rs.svg';
import RU from './images/svg/flags/ru.svg';
import RW from './images/svg/flags/rw.svg';
import SA from './images/svg/flags/sa.svg';
import SB from './images/svg/flags/sb.svg';
import SC from './images/svg/flags/sc.svg';
import SD from './images/svg/flags/sd.svg';
import SE from './images/svg/flags/se.svg';
import SG from './images/svg/flags/sg.svg';
import SH from './images/svg/flags/sh.svg';
import SI from './images/svg/flags/si.svg';
import SJ from './images/svg/flags/sj.svg';
import SK from './images/svg/flags/sk.svg';
import SL from './images/svg/flags/sl.svg';
import SM from './images/svg/flags/sm.svg';
import SN from './images/svg/flags/sn.svg';
import SO from './images/svg/flags/so.svg';
import SR from './images/svg/flags/sr.svg';
import SS from './images/svg/flags/ss.svg';
import ST from './images/svg/flags/st.svg';
import SV from './images/svg/flags/sv.svg';
import SX from './images/svg/flags/sx.svg';
import SY from './images/svg/flags/sy.svg';
import SZ from './images/svg/flags/sz.svg';
import TC from './images/svg/flags/tc.svg';
import TD from './images/svg/flags/td.svg';
import TF from './images/svg/flags/tf.svg';
import TG from './images/svg/flags/tg.svg';
import TH from './images/svg/flags/th.svg';
import TJ from './images/svg/flags/tj.svg';
import TK from './images/svg/flags/tk.svg';
import TL from './images/svg/flags/tl.svg';
import TM from './images/svg/flags/tm.svg';
import TN from './images/svg/flags/tn.svg';
import TO from './images/svg/flags/to.svg';
import TR from './images/svg/flags/tr.svg';
import TT from './images/svg/flags/tt.svg';
import TV from './images/svg/flags/tv.svg';
import TW from './images/svg/flags/tw.svg';
import TZ from './images/svg/flags/tz.svg';
import UA from './images/svg/flags/ua.svg';
import UG from './images/svg/flags/ug.svg';
import UM from './images/svg/flags/um.svg';
import US from './images/svg/flags/us.svg';
import UY from './images/svg/flags/uy.svg';
import UZ from './images/svg/flags/uz.svg';
import VA from './images/svg/flags/va.svg';
import VC from './images/svg/flags/vc.svg';
import VE from './images/svg/flags/ve.svg';
import VG from './images/svg/flags/vg.svg';
import VI from './images/svg/flags/vi.svg';
import VN from './images/svg/flags/vn.svg';
import VU from './images/svg/flags/vu.svg';
import WF from './images/svg/flags/wf.svg';
import WS from './images/svg/flags/ws.svg';
import YE from './images/svg/flags/ye.svg';
import YT from './images/svg/flags/yt.svg';
import ZA from './images/svg/flags/za.svg';
import ZM from './images/svg/flags/zm.svg';
import ZW from './images/svg/flags/zw.svg';

export const Flags: Record<string, string> = {
  AD,
  AE,
  AF,
  AG,
  AI,
  AL,
  AM,
  AN,
  AO,
  AQ,
  AR,
  AS,
  AT,
  AU,
  AW,
  AX,
  AZ,
  BA,
  BB,
  BD,
  BE,
  BF,
  BG,
  BH,
  BI,
  BJ,
  BL,
  BM,
  BN,
  BO,
  BQ,
  BR,
  BS,
  BT,
  BV,
  BW,
  BY,
  BZ,
  CA,
  CC,
  CD,
  CF,
  CG,
  CH,
  CI,
  CK,
  CL,
  CM,
  CN,
  CO,
  CR,
  CU,
  CV,
  CW,
  CX,
  CY,
  CZ,
  DE,
  DJ,
  DK,
  DM,
  DO,
  DZ,
  EC,
  EE,
  EG,
  EH,
  ER,
  ES,
  ET,
  FI,
  FJ,
  FK,
  FM,
  FO,
  FR,
  GA,
  GB,
  GD,
  GE,
  GF,
  GG,
  GH,
  GI,
  GL,
  GM,
  GN,
  GP,
  GQ,
  GR,
  GS,
  GT,
  GU,
  GW,
  GY,
  HK,
  HM,
  HN,
  HR,
  HT,
  HU,
  ID,
  IE,
  IL,
  IM,
  IN,
  IO,
  IQ,
  IR,
  IS,
  IT,
  JE,
  JM,
  JO,
  JP,
  KE,
  KG,
  KH,
  KI,
  KM,
  KN,
  KP,
  KR,
  KW,
  KY,
  KZ,
  LA,
  LB,
  LC,
  LI,
  LK,
  LR,
  LS,
  LT,
  LU,
  LV,
  LY,
  MA,
  MC,
  MD,
  ME,
  MF,
  MG,
  MH,
  MK,
  ML,
  MM,
  MN,
  MO,
  MP,
  MQ,
  MR,
  MS,
  MT,
  MU,
  MV,
  MW,
  MX,
  MY,
  MZ,
  NA,
  NC,
  NE,
  NF,
  NG,
  NI,
  NL,
  NO,
  NP,
  NR,
  NU,
  NZ,
  OM,
  PA,
  PE,
  PF,
  PG,
  PH,
  PK,
  PL,
  PM,
  PN,
  PR,
  PS,
  PT,
  PW,
  PY,
  QA,
  RE,
  RO,
  RS,
  RU,
  RW,
  SA,
  SB,
  SC,
  SD,
  SE,
  SG,
  SH,
  SI,
  SJ,
  SK,
  SL,
  SM,
  SN,
  SO,
  SR,
  SS,
  ST,
  SV,
  SX,
  SY,
  SZ,
  TC,
  TD,
  TF,
  TG,
  TH,
  TJ,
  TK,
  TL,
  TM,
  TN,
  TO,
  TR,
  TT,
  TV,
  TW,
  TZ,
  UA,
  UG,
  UM,
  US,
  UY,
  UZ,
  VA,
  VC,
  VE,
  VG,
  VI,
  VN,
  VU,
  WF,
  WS,
  YE,
  YT,
  ZA,
  ZM,
  ZW,
};
